import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { ProfileProvider } from './context/ProfileContext'
import Navbar from './components/Navbar'
import Footer from './components/Footer'
import Discover from './pages/Discover'
import AllBrands from './pages/AllBrands'
import MyBrands from './pages/MyBrands'
import Listings from './pages/Listings'
import NewBrands from './pages/NewBrands'
import SizeGuide from './pages/SizeGuide'
import About from './pages/About'
import Legal from './pages/Legal'
import ForgotPassword from './pages/ForgotPassword'
import ResetPassword from './pages/ResetPassword'
import Unsubscribe from './pages/Unsubscribe'
import './App.css'

function App() {
  return (
    <AuthProvider>
      <ProfileProvider>
        <BrowserRouter>
          <div className="app">
            <Navbar />
            <main className="main-content">
              <Routes>
                <Route path="/" element={<Discover />} />
                <Route path="/brands" element={<AllBrands />} />
                <Route path="/my-brands" element={<MyBrands />} />
                <Route path="/listings" element={<Listings />} />
                <Route path="/new" element={<NewBrands />} />
                <Route path="/size-guide" element={<SizeGuide />} />
                <Route path="/about" element={<About />} />
                <Route path="/legal" element={<Legal />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route path="/unsubscribe" element={<Unsubscribe />} />
              </Routes>
            </main>
            <Footer />
          </div>
        </BrowserRouter>
      </ProfileProvider>
    </AuthProvider>
  )
}

export default App
